import React, { memo, useMemo } from 'react';
import { Container, Row, Col, Image, Badge } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { useTranslation } from "react-i18next";

// サンプルデータ
const sampleData = [
    {
        id: 1,
        name: "アニメ風美少女",
        thumbnail: "/img/samples/anime_girl.jpg",
        prompt: "anime style, 1girl, beautiful face, long hair, blue eyes, school uniform, detailed, high quality",
        negativePrompt: "lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username, blurry",
        steps: 20,
        cfgScale: 7,
        sampler: "DPM++ 2M Karras",
        model: "Animagine XL 3.1",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 2,
        name: "ファンタジー風景",
        thumbnail: "/img/samples/fantasy_landscape.jpg",
        prompt: "fantasy landscape, magical forest, floating islands, mystical lighting, detailed environment, concept art style",
        negativePrompt: "lowres, bad quality, blurry, simple, plain",
        steps: 25,
        cfgScale: 8,
        sampler: "Euler a",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 3,
        name: "サイバーパンク都市",
        thumbnail: "/img/samples/cyberpunk_city.jpg",
        prompt: "cyberpunk cityscape, neon lights, futuristic buildings, rain, night scene, atmospheric",
        negativePrompt: "lowres, bad quality, blurry, simple",
        steps: 30,
        cfgScale: 7.5,
        sampler: "DPM++ SDE Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 4,
        name: "リアル風ポートレート",
        thumbnail: "/img/samples/realistic_portrait.jpg",
        prompt: "realistic portrait, professional photography, detailed skin, natural lighting, high resolution",
        negativePrompt: "cartoon, anime, painting, illustration, lowres, bad anatomy",
        steps: 35,
        cfgScale: 6,
        sampler: "DPM++ 2M",
        model: "Realistic Vision v6.0",
        vae: "vae-ft-mse-840000-ema-pruned.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 5,
        name: "水彩画風",
        thumbnail: "/img/samples/watercolor.jpg",
        prompt: "watercolor painting, soft brushstrokes, gentle colors, artistic style, traditional art",
        negativePrompt: "digital, photographic, sharp, harsh",
        steps: 28,
        cfgScale: 7,
        sampler: "Euler a",
        model: "Anything v5",
        vae: "kl-f8-anime2.safetensors",
        width: 896,
        height: 1152
    },
    {
        id: 6,
        name: "メカニック・ロボット",
        thumbnail: "/img/samples/mecha_robot.jpg",
        prompt: "mecha robot, detailed mechanical parts, metallic surface, sci-fi design, high quality",
        negativePrompt: "organic, soft, blurry, low quality",
        steps: 32,
        cfgScale: 8,
        sampler: "DPM++ 2M Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 7,
        name: "猫カフェ",
        thumbnail: "/img/samples/cat_cafe.jpg",
        prompt: "cute cat, coffee shop, cozy atmosphere, warm lighting, kawaii style",
        negativePrompt: "dark, scary, aggressive",
        steps: 25,
        cfgScale: 7,
        sampler: "Euler a",
        model: "Anything v5",
        vae: "kl-f8-anime2.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 8,
        name: "宇宙ステーション",
        thumbnail: "/img/samples/space_station.jpg",
        prompt: "space station, futuristic, stars, earth view, sci-fi architecture",
        negativePrompt: "fantasy, medieval, low quality",
        steps: 30,
        cfgScale: 8,
        sampler: "DPM++ SDE Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 9,
        name: "桜並木",
        thumbnail: "/img/samples/sakura_path.jpg",
        prompt: "cherry blossom, sakura, spring, peaceful path, pink petals falling",
        negativePrompt: "winter, autumn, dead leaves",
        steps: 28,
        cfgScale: 7.5,
        sampler: "DPM++ 2M",
        model: "Realistic Vision v6.0",
        vae: "vae-ft-mse-840000-ema-pruned.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 10,
        name: "ドラゴン",
        thumbnail: "/img/samples/dragon.jpg",
        prompt: "majestic dragon, fantasy creature, detailed scales, fire breathing, epic",
        negativePrompt: "cartoonish, simple, low detail",
        steps: 35,
        cfgScale: 8.5,
        sampler: "DPM++ 2M Karras",
        model: "Animagine XL 3.1",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 11,
        name: "未来都市夜景",
        thumbnail: "/img/samples/future_city_night.jpg",
        prompt: "futuristic city at night, neon lights, flying cars, cyberpunk aesthetic",
        negativePrompt: "old, vintage, daylight",
        steps: 32,
        cfgScale: 7.5,
        sampler: "DPM++ SDE Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 12,
        name: "魔法使い",
        thumbnail: "/img/samples/wizard.jpg",
        prompt: "wizard, magic staff, mystical robes, spell casting, fantasy portrait",
        negativePrompt: "modern, technology, realistic",
        steps: 30,
        cfgScale: 8,
        sampler: "Euler a",
        model: "Anything v5",
        vae: "kl-f8-anime2.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 13,
        name: "海底神殿",
        thumbnail: "/img/samples/underwater_temple.jpg",
        prompt: "underwater temple, ancient ruins, blue water, mysterious atmosphere, fish swimming",
        negativePrompt: "desert, land, bright sunlight",
        steps: 28,
        cfgScale: 7,
        sampler: "DPM++ 2M",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 14,
        name: "スチームパンク街",
        thumbnail: "/img/samples/steampunk_city.jpg",
        prompt: "steampunk city, brass machinery, steam pipes, Victorian architecture, industrial",
        negativePrompt: "modern, clean, futuristic",
        steps: 30,
        cfgScale: 8,
        sampler: "DPM++ 2M Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 15,
        name: "忍者",
        thumbnail: "/img/samples/ninja.jpg",
        prompt: "ninja, black outfit, katana, stealthy pose, Japanese traditional, moonlight",
        negativePrompt: "bright colors, western, modern",
        steps: 32,
        cfgScale: 7.5,
        sampler: "DPM++ SDE Karras",
        model: "Animagine XL 3.1",
        vae: "sdxl_vae.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 16,
        name: "結晶洞窟",
        thumbnail: "/img/samples/crystal_cave.jpg",
        prompt: "crystal cave, glowing gems, underground, mystical lighting, magical atmosphere",
        negativePrompt: "dark, plain rock, surface",
        steps: 28,
        cfgScale: 8,
        sampler: "Euler a",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 17,
        name: "パステル風女の子",
        thumbnail: "/img/samples/pastel_girl.jpg",
        prompt: "pastel colors, cute girl, soft lighting, kawaii, sweet atmosphere, anime style",
        negativePrompt: "dark colors, scary, realistic",
        steps: 25,
        cfgScale: 7,
        sampler: "DPM++ 2M",
        model: "Anything v5",
        vae: "kl-f8-anime2.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 18,
        name: "古代遺跡",
        thumbnail: "/img/samples/ancient_ruins.jpg",
        prompt: "ancient ruins, overgrown with plants, mysterious, archaeological site, weathered stone",
        negativePrompt: "modern, new, clean",
        steps: 30,
        cfgScale: 7.5,
        sampler: "DPM++ 2M Karras",
        model: "Realistic Vision v6.0",
        vae: "vae-ft-mse-840000-ema-pruned.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 19,
        name: "機械天使",
        thumbnail: "/img/samples/mechanical_angel.jpg",
        prompt: "mechanical angel, cyberpunk wings, halo, futuristic, detailed machinery, divine",
        negativePrompt: "organic, natural, simple",
        steps: 35,
        cfgScale: 8.5,
        sampler: "DPM++ SDE Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 20,
        name: "和風庭園",
        thumbnail: "/img/samples/japanese_garden.jpg",
        prompt: "Japanese garden, zen, bamboo, stone lantern, peaceful, traditional architecture",
        negativePrompt: "western, modern, chaotic",
        steps: 28,
        cfgScale: 7,
        sampler: "Euler a",
        model: "Realistic Vision v6.0",
        vae: "vae-ft-mse-840000-ema-pruned.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 21,
        name: "宇宙船内部",
        thumbnail: "/img/samples/spaceship_interior.jpg",
        prompt: "spaceship interior, control panels, futuristic technology, sci-fi cockpit, blue lighting",
        negativePrompt: "fantasy, medieval, outdoor",
        steps: 32,
        cfgScale: 8,
        sampler: "DPM++ 2M",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 22,
        name: "魔法の森",
        thumbnail: "/img/samples/magical_forest.jpg",
        prompt: "magical forest, glowing mushrooms, fairy lights, enchanted atmosphere, mystical creatures",
        negativePrompt: "urban, technology, realistic forest",
        steps: 30,
        cfgScale: 8,
        sampler: "DPM++ 2M Karras",
        model: "Anything v5",
        vae: "kl-f8-anime2.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 23,
        name: "サムライ",
        thumbnail: "/img/samples/samurai.jpg",
        prompt: "samurai warrior, katana, traditional armor, fierce expression, Japanese historical",
        negativePrompt: "modern, western, peaceful",
        steps: 32,
        cfgScale: 7.5,
        sampler: "DPM++ SDE Karras",
        model: "Animagine XL 3.1",
        vae: "sdxl_vae.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 24,
        name: "氷の城",
        thumbnail: "/img/samples/ice_castle.jpg",
        prompt: "ice castle, frozen palace, winter landscape, crystal structures, cold atmosphere",
        negativePrompt: "warm, summer, desert",
        steps: 28,
        cfgScale: 8,
        sampler: "Euler a",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 25,
        name: "蒸気機関車",
        thumbnail: "/img/samples/steam_train.jpg",
        prompt: "steam locomotive, vintage train, railway station, industrial era, smoke and steam",
        negativePrompt: "modern train, electric, futuristic",
        steps: 30,
        cfgScale: 7.5,
        sampler: "DPM++ 2M",
        model: "Realistic Vision v6.0",
        vae: "vae-ft-mse-840000-ema-pruned.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 26,
        name: "エルフ戦士",
        thumbnail: "/img/samples/elf_warrior.jpg",
        prompt: "elf warrior, bow and arrow, forest guardian, elegant armor, fantasy character",
        negativePrompt: "human, modern, technology",
        steps: 32,
        cfgScale: 8,
        sampler: "DPM++ 2M Karras",
        model: "Anything v5",
        vae: "kl-f8-anime2.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 27,
        name: "浮遊島",
        thumbnail: "/img/samples/floating_island.jpg",
        prompt: "floating island, sky kingdom, waterfalls, fantasy landscape, clouds below",
        negativePrompt: "ground level, realistic, urban",
        steps: 28,
        cfgScale: 8,
        sampler: "DPM++ SDE Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1152,
        height: 896
    },
    {
        id: 28,
        name: "賢者の塔",
        thumbnail: "/img/samples/wizard_tower.jpg",
        prompt: "wizard tower, magical laboratory, spell books, crystal ball, mystical interior",
        negativePrompt: "modern, technology, outdoor",
        steps: 30,
        cfgScale: 7.5,
        sampler: "Euler a",
        model: "Anything v5",
        vae: "kl-f8-anime2.safetensors",
        width: 1024,
        height: 1024
    },
    {
        id: 29,
        name: "バイカー女子",
        thumbnail: "/img/samples/biker_girl.jpg",
        prompt: "biker girl, motorcycle, leather jacket, cool pose, urban setting, detailed",
        negativePrompt: "fantasy, medieval, cute",
        steps: 32,
        cfgScale: 7,
        sampler: "DPM++ 2M",
        model: "Realistic Vision v6.0",
        vae: "vae-ft-mse-840000-ema-pruned.safetensors",
        width: 768,
        height: 1024
    },
    {
        id: 30,
        name: "星空カフェ",
        thumbnail: "/img/samples/starry_cafe.jpg",
        prompt: "starry night cafe, outdoor terrace, romantic atmosphere, city lights, couple dining",
        negativePrompt: "daylight, indoor, busy",
        steps: 28,
        cfgScale: 7.5,
        sampler: "DPM++ 2M Karras",
        model: "SDXL Base 1.0",
        vae: "sdxl_vae.safetensors",
        width: 1024,
        height: 1024
    }
];

const SampleCollection = ({ show, onSelect }) => {
    const { t } = useTranslation();

    const handleSampleClick = (sample) => {
        onSelect(sample);
    };

    // useMemoでサンプルレンダリングを最適化
    const sampleItems = useMemo(() => {
        return sampleData.map((sample) => (
            <Col xs={6} sm={4} md={3} lg={3} xl={2} xxl={2} key={sample.id}>
                <div 
                    className="sample-item border rounded p-2 h-100 cursor-pointer"
                    style={{ 
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        border: '1px solid #dee2e6',
                        minHeight: '280px',
                        maxHeight: '280px'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = '#0d6efd';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = '#dee2e6';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                    onClick={() => handleSampleClick(sample)}
                >
                    <div className="text-center d-flex flex-column h-100">
                        <Image 
                            src={sample.thumbnail}
                            alt={sample.name}
                            style={{ 
                                width: '100%', 
                                height: '140px', 
                                objectFit: 'cover',
                                borderRadius: '6px'
                            }}
                            onError={(e) => {
                                e.target.src = '/img/no-image.png';
                            }}
                        />
                        <div className="flex-grow-1 d-flex flex-column justify-content-between mt-2">
                            <h6 className="mb-1" style={{ 
                                fontSize: '0.9rem', 
                                lineHeight: '1.2',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: '600'
                            }}>
                                {sample.name}
                            </h6>
                            <div className="mb-2">
                                <Badge bg="primary" className="me-1 mb-1" style={{ fontSize: '0.75rem', padding: '4px 8px' }}>
                                    {sample.model}
                                </Badge>
                                <Badge bg="info" className="mb-1" style={{ fontSize: '0.75rem', padding: '4px 8px' }}>
                                    {sample.sampler}
                                </Badge>
                            </div>
                            <div className="text-muted small" style={{ fontSize: '0.8rem', lineHeight: '1.3' }}>
                                <div>解像度: {sample.width}×{sample.height}</div>
                                <div>Steps: {sample.steps} | CFG: {sample.cfgScale}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        ));
    }, []);

    return (
        <Container fluid style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
            <Row className="g-4">
                {sampleItems}
            </Row>
        </Container>
    );
};

export default memo(SampleCollection);